const isLocalhost = () => window.location.host.includes('localhost')

const isDev = () => window.location.host.includes('.dev')

const isBeta = () => window.location.host.includes('.beta')

const isProduction = () => (!isBeta() && !isDev() && !isLocalhost())

export {
  isProduction,
  isBeta,
  isDev,
  isLocalhost
}

export default {}
